import axios from "axios";
// const HOST = 'http://127.0.0.1:1888/api/admin/';
// const HOST = 'http://192.168.2.94:1888/api/admin/';

 const HOST = 'https://api-aclub.r-erp.cc/api/admin/';

 
const host_upload = "https://xf-aplus.oss-cn-hongkong.aliyuncs.com/";//上传


import {
  ElLoading,
  ElMessageBox, ElMessage
} from 'element-plus';

//默认协议头
let header = {
  'Content-Type': 'application/json',
  'tokens': ''
}

//合并协议头
function extend(e, t) {
  for (var i in t) {
    e[i] = t[i];
  }
  return e;
}

function ajax(type, url, options, head) {
  header.tokens = localStorage.getItem("tokens");
  head ? extend(head, header) : head = header //合并协议头
  return axios({
    method: type,
    url: HOST + url,
    params: type != 'get' ? null : options,
    data: type == 'get' ? null : options,
    timeout: 10000, //请求超时
    responseType: 'json', // 响应的数据类型
    headers: head, //设置头部
  }).then(function (res) {
    if (res.data.code != 200) {
      if (res.data.code == 401) {
        window.location = "/login"
        return false;
      } else {
        const loadingInstance = ElLoading.service({});
        loadingInstance.close();
        ElMessageBox.alert(res.data.msg, "提示", {
          type: "error",
          showClose: false,
          confirmButtonText: '确定',
          callback: action => {
            if (action === 'confirm') {
              // 用户点击了确定  
            } else if (action === 'cancel') {
              // 用户点击了取消（如果对话框有取消按钮的话）  
            }
          }
        });

        return false;
      }
    } else {
      if (url == 'user/login') {
        localStorage.setItem('tokens', res.headers.tokens);
      };
      return res.data
    }


  }).catch(function (error) {
    return false
  });
};


/**
 * 'videopath/' 
 * @param {*} file 
 * @param {*} res  里面是秘钥 包含 videopath/' 目录
 * @returns 
 */
function getupload(file, res) {
  let hz = file.name.split('.')[1]
  let name = Date.parse(new Date())
  name = String(name).substring(String(name).length - 6);
  name = 100 + Math.ceil(Math.random() * 900) + name;
  name = name + 100 + Math.ceil(Math.random() * 900) + '.' + hz;
  let formData = new FormData();
  res.directory = "adm/";
  formData.append('key', res.directory + name)
  formData.append('OSSAccessKeyId', res.accessid)
  formData.append('policy', res.policy)
  formData.append('Signature', res.signature)
  formData.append('success_action_status', 200)
  formData.append('file', file)
  return axios({
    method: 'post',
    url: host_upload,
    data: formData,
    timeout: 120000, //请求超时
    responseType: 'json', // 响应的数据类型
  }).then(function (e) {
    let data = { code: 200, url: host_upload + res.directory + name };
    return data
  }).catch(() => {
    return
  })
}



//参数名称：图片地址、参数、协议头、
export default {

  async get(url, options, head) {
    return await ajax('get', url, options, head);
  },

  async post(url, options, head) {
    return await ajax('post', url, JSON.stringify(options), head);
  },

  async upload(options, res) {
    return await getupload(options, res)
  },
};
